export const SET_TOP_PICKS = 'setTopPicks';